import React, { useState, useEffect } from 'react';
import HomePage from './HomePage.js';
import './App.css';
import desktopBg from './assets/desktop background_result.webp';

function App() {
  // const [password, setPassword] = useState('');
  // const [accessGranted, setAccessGranted] = useState(false);
  // const [error, setError] = useState('');
  const [bgLoaded, setBgLoaded] = useState(false);

  // const correctPassword = 'manchego';

  // Preload both background images
  useEffect(() => {
    const desktop = new Image();
    desktop.src = desktopBg;

    desktop.onload = () => setBgLoaded(true);
  }, []);

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (password === correctPassword) {
  //     setAccessGranted(true);
  //     setError('');
  //   } else {
  //     setError('Incorrect password. Please try again.');
  //   }
  // };

  return (
    <div className="app-container">
      {/* Show background only after it's loaded */}
      {bgLoaded && <BackgroundImage />}
      
      {/* {accessGranted ? (
        <HomePage />
      ) : (
        <div className="app">
          <div className="welcome">
            <div className="welcomeText">
              <div>Welcome to the housesitting website!</div>
              <div>This site is still under construction...</div>
            </div>
            <div className="passwordModal">
              <form onSubmit={handleSubmit}>
                <div>Enter password to see the work-in-progress site</div>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button type="submit">Submit</button>
              </form>
              {error && <div>{error}</div>}
            </div>
          </div>
        </div>
      )} */}

      <HomePage />
    </div>
  );
}

function BackgroundImage() {
  return (
    <>
      <img src={desktopBg} alt="background" className="background desktop" />
    </>
  );
}

export default App;
